module.exports = __webpack_public_path__ + "static/media/asenso-logo2.1f1e2738.png";